import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { fas } from '@fortawesome/free-solid-svg-icons'

import {
  faFacebookF,
  faGoogle,
  faInstagram,
  faMailchimp,
  faMicrosoft,
  faLinkedinIn,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons'

library.add(
  fas,
  faFacebookF,
  faGoogle,
  faInstagram,
  faMailchimp,
  faMicrosoft,
  faLinkedinIn,
  faLinkedin
)

Vue.component('fa', FontAwesomeIcon)
